var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { nanoid } from 'nanoid';
import { computed, observable, makeObservable } from 'mobx';
import { deserialize, object, primitive } from '../../../utils/serializr/serializr';
import { AnswerStore } from './modules/AnswerStore';
import { date } from '../../../utils/serializr/schema/inner/date';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { withInit } from '../../../utils/serializr/schema/middle/withInit';
import { runtime } from '../../runtime/Runtime';
import { AnswerPrepare } from './modules/AnswerPrepare';
import { AnswerAttributes } from './modules/AnswerAttributes';
import { AnswerInfo } from './modules/AnswerInfo';
import { AnswerSkip } from './modules/AnswerSkip';
export class Answer {
    parent;
    type = 'answer';
    id;
    poseDate;
    completeDate;
    finishDate;
    enforceTipDate;
    enforcePushDate;
    /* @observable */ question_id;
    /* @observable */ user_id;
    /* @observable */ topic_id;
    wasSkipped = false;
    wasBlocked = false;
    wasContinuedImmedately = false;
    platform = 1;
    evalflag = 0;
    flag = 0;
    cycle = '';
    answerStore;
    textSizeGroupLoops = {};
    constructor({ parent }) {
        makeObservable(this);
        this.parent = parent;
    }
    get app() {
        return this.parent;
    }
    get answerPrepare() {
        return new AnswerPrepare(this);
    }
    get answerAttributes() {
        return new AnswerAttributes(this);
    }
    get answerInfo() {
        return new AnswerInfo(this);
    }
    get answerSkip() {
        return new AnswerSkip(this);
    }
    get model() {
        return runtime.model.getNewModel(this);
    }
    get streamedQuestion() {
        if (!this.question_id)
            return null;
        return this.model.stream.question[this.question_id];
    }
    get availableQuestion() {
        if (!this.question_id)
            return null;
        return this.model.available.question[this.question_id];
    }
    get solidQuestion() {
        return this.question;
    }
    get question() {
        return this.streamedQuestion;
    }
    get points() {
        return this.answerAttributes.points;
    }
    set points(v) {
        this.answerAttributes.points = v;
    }
    get maxPoints() {
        return this.answerAttributes.maxPoints;
    }
    set maxPoints(v) {
        this.answerAttributes.maxPoints = v;
    }
    get avg() {
        return this.answerAttributes.avg;
    }
    set avg(v) {
        this.answerAttributes.avg = v;
    }
    get evaltext() {
        return this.answerAttributes.evaltext;
    }
    set evaltext(v) {
        this.answerAttributes.evaltext = v;
    }
    get deviationOfAverage() {
        return this.points / this.maxPoints - this.avg;
    }
    get miniQuestion() {
        const mini = (this.app.topic && this.app.topic.topicMiniQuestions.miniQuestions.find(q => q.id === this.question_id)) ||
            (this.app.funnel.funnelReward.rewardTopic &&
                this.app.funnel.funnelReward.rewardTopic.topicMiniQuestions.miniQuestions.find(q => q.id === this.question_id));
        if (!mini || !mini.micro)
            return undefined;
        return mini;
    }
    get owningCycle() {
        return this.app.tray.trayCycles.allCycles[Math.floor(this.answerInfo.indexInTray / this.app.tray.trayCycles.pensumPerCycle)];
    }
    get indexInCycle() {
        return this.owningCycle.cycleAnswers.allAnswersInCycle.indexOf(this);
    }
    async stageMe() {
        await this.app.directive.directivePoseQuestion.poseAnswer(this);
    }
    static fromSerialized(ser = {}) {
        return deserialize(Answer, ser);
    }
    static get serializeInfo() {
        return {
            props: {
                id: withInit(primitive, () => nanoid(12)),
                answerStore: withInit(object(AnswerStore), {}),
                user_id: true,
                question_id: true,
                topic_id: true,
                completeDate: date(),
                points: true,
                maxPoints: true,
                avg: true,
                evaltext: true,
                evalflag: true,
                flag: true,
                platform: true,
                cycle: true,
            },
        };
    }
}
__decorate([
    observable.ref
], Answer.prototype, "poseDate", void 0);
__decorate([
    observable.ref
], Answer.prototype, "completeDate", void 0);
__decorate([
    observable.ref
], Answer.prototype, "finishDate", void 0);
__decorate([
    observable.ref
], Answer.prototype, "enforceTipDate", void 0);
__decorate([
    observable.ref
], Answer.prototype, "enforcePushDate", void 0);
__decorate([
    observable.ref
], Answer.prototype, "wasSkipped", void 0);
__decorate([
    observable.ref
], Answer.prototype, "wasBlocked", void 0);
__decorate([
    observable.ref
], Answer.prototype, "wasContinuedImmedately", void 0);
__decorate([
    memoize
], Answer.prototype, "answerPrepare", null);
__decorate([
    memoize
], Answer.prototype, "answerAttributes", null);
__decorate([
    memoize
], Answer.prototype, "answerInfo", null);
__decorate([
    memoize
], Answer.prototype, "answerSkip", null);
__decorate([
    memoize
], Answer.prototype, "model", null);
__decorate([
    computed // necessary, otherwise bug in reactions !!!!
], Answer.prototype, "streamedQuestion", null);
__decorate([
    computed
], Answer.prototype, "availableQuestion", null);
__decorate([
    computed // necessary?
], Answer.prototype, "question", null);
__decorate([
    computed
], Answer.prototype, "miniQuestion", null);
__decorate([
    memoize
], Answer, "serializeInfo", null);
